export default function guest({ next, to, store }) {
  let subejctId;
  store.getters['subject/currentSubject'] ? (subejctId = store.getters['subject/currentSubject'].id) : null;
  if (!store.getters['subject/currentSubject'] || subejctId != to.params.subject_id) {
    store.dispatch('subject/FETCH_SINGLE', to.params.subject_id).then(res => {
      store.commit('subject/SET_CURRENT_SUBJECT', res.data);
    });
  }
  return next();
}
